export default "__VITE_ASSET__DJd161bP__"